import { render } from "./TimeTableWrapper.vue?vue&type=template&id=48b43fe2&scoped=true"
import script from "./TimeTableWrapper.vue?vue&type=script&lang=js"
export * from "./TimeTableWrapper.vue?vue&type=script&lang=js"

import "./TimeTableWrapper.vue?vue&type=style&index=0&id=48b43fe2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48b43fe2"]])

export default __exports__